export default [
    {
        path: '/categories',
        name: 'categories',
        meta: { layout: 'dashboard' },
        component: () => import('VIEWS/Catalogs/Categories.vue')
    }
]
